import axios from "axios";

declare module "axios" {
  export interface AxiosRequestConfig {
    _originalData?: any;
    _retry?: boolean;
    signal?: AbortSignal;
  }
}

export const axiosInstance = axios.create({
    //baseURL: 'http://localhost:4000/api/',
    baseURL: 'https://api.cbsystem.net.pe/api/',
    timeout: 20000
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage['accessToken'];
        if (token) {
            config.headers = {
                'Authorization': `Bearer ${token}`
            }
        }
        // Guarda el body original para posibles reintentos
        if (config.data) {
            config._originalData = config.data;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalConfig = error.config;
        if (error.response && error.response.status === 401 && !originalConfig._retry) {
            originalConfig._retry = true;
            try {
                const res = await axiosInstance.post('/auth/token', { token: localStorage['refreshToken'] });
                localStorage.setItem('accessToken', res.data.accessToken);
                axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${localStorage['accessToken']}`;
                // Restaurar el body original si existe
                if (originalConfig._originalData) {
                    originalConfig.data = originalConfig._originalData;
                }
                return axiosInstance(originalConfig);
            } catch (refreshError: any) {
                localStorage.clear();
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);
